import {getSiteLocale} from '@util/LocaleUtils';
import {SCHEMA_VERSION} from '../../../../api/schema.version';
import {CachePersistor} from 'apollo-cache-persist';
import deepEqual from 'deep-equal';
import pathOr from 'ramda/src/pathOr';

const USER_META = pathOr( {}, ['upi', 'User', 'info'], window );
const CACHE_META_KEY = 'apollo-cache-meta';
const CACHE_META = {
    ...USER_META,
    locale: getSiteLocale(),
    schemaVersion: SCHEMA_VERSION
};

// Try to enable state persistence with localStorage if available


export default {
    init: cache => {
        try {
            const persistor = new CachePersistor( {
                cache,
                storage: window.localStorage,
                debounce: 200,
                maxSize: false
            } );
            const storageProvider = persistor.storage.storage;
            const cacheMeta = JSON.parse( storageProvider.getItem( CACHE_META_KEY ) );

            window.addEventListener( 'error', function ( e ) {
                if ( e.error && e.error.name === 'QuotaExceededError' ) {
                    persistor.purge();
                }
            } );

            if ( deepEqual( cacheMeta, CACHE_META ) ) {
                persistor.restore();
            }
            else {
                persistor.purge();
                console.warn( '[ApolloClient] Cache purged... version:', SCHEMA_VERSION );
                storageProvider.setItem( CACHE_META_KEY, JSON.stringify( CACHE_META ) )
            }
        }
        catch ( err ) {
            console.warn( '[Apollo CachePersistor] Persistor disabled - localStorage not available')
        }
    }
}